import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faUsers, faMoneyBillWave, faChartLine, faRocket } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticUrgencySection.css';
import { useTranslation } from 'react-i18next';

const LogisticUrgencySection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-urgency-section">
      <div className="logistic-container">
        <div className="logistic-urgency-content">
          <div className="logistic-urgency-icon">
            <FontAwesomeIcon icon={faExclamationTriangle} />
          </div>
          <h2>{t('LogisticUrgencySection:title')}</h2>
          <p>{t('LogisticUrgencySection:subtitle')}</p>
          
          <div className="logistic-urgency-losses">
            <div className="logistic-loss-item">
              <FontAwesomeIcon icon={faUsers} />
              <div>
                <strong>{t('LogisticUrgencySection:loss1_strong')}</strong>
                <p>{t('LogisticUrgencySection:loss1_text')}</p>
              </div>
            </div>
            <div className="logistic-loss-item">
              <FontAwesomeIcon icon={faMoneyBillWave} />
              <div>
                <strong>{t('LogisticUrgencySection:loss2_strong')}</strong>
                <p>{t('LogisticUrgencySection:loss2_text')}</p>
              </div>
            </div>
            <div className="logistic-loss-item">
              <FontAwesomeIcon icon={faChartLine} />
              <div>
                <strong>{t('LogisticUrgencySection:loss3_strong')}</strong>
                <p>{t('LogisticUrgencySection:loss3_text')}</p>
              </div>
            </div>
          </div>

          <div className="logistic-urgency-cta">
            <p className="logistic-urgency-text">
              <strong>{t('LogisticUrgencySection:cta_text_strong')}</strong>
              {t('LogisticUrgencySection:cta_text_suffix')}
            </p>
            <a href="#cta" className="logistic-btn-urgent">
              <FontAwesomeIcon icon={faRocket} />
              {t('LogisticUrgencySection:cta_button')}
            </a>
            <p className="logistic-urgency-note">{t('LogisticUrgencySection:cta_note')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticUrgencySection;